import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// src/index.js or src/index.css
import 'leaflet/dist/leaflet.css';
import App from './App.jsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

